"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_bootstrap_1 = require("react-bootstrap");
var AcButton_1 = require("../../button/AcButton");
var AcFormField_1 = require("../../form/AcFormField");
var AcPdf_1 = require("../../pdf/AcPdf");
var NotPersonInCharge_1 = require("./NotPersonInCharge");
exports.SaveAndClose = function (_a) {
    var show = _a.show, initalNote = _a.initalNote, closeSaveAndClose = _a.closeSaveAndClose, closePdfEditor = _a.closePdfEditor, onCreateDraft = _a.onCreateDraft;
    var canvasMethodsRef = react_1.useContext(AcPdf_1.CanvasContext);
    var _b = react_1.useState(initalNote || ''), noteField = _b[0], setNoteField = _b[1];
    var _c = react_1.useState(false), isNoteFieldError = _c[0], setIsNoteFieldError = _c[1];
    var _d = react_1.useState(false), showNotPersonInCharge = _d[0], setShowNotPersonInCharge = _d[1];
    react_1.useEffect(function () {
        setNoteField(initalNote || '');
    }, [initalNote]);
    var formProps = {
        type: 'textarea',
        rows: 3,
        onChange: function (_, value) {
            setIsNoteFieldError(value.length > 255);
            setNoteField(value);
        },
        value: noteField,
        placeholder: 'メモ入力してください（任意）',
        invalid: isNoteFieldError,
        errorId: 'メモは255文字以内でご入力ください',
    };
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var fabricDataMap, fabricDataMapJSON, numPages, userInCharge;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fabricDataMap = canvasMethodsRef.current.getFabricDataMap();
                    fabricDataMapJSON = JSON.stringify(fabricDataMap);
                    numPages = canvasMethodsRef.current.getExistingPages().length;
                    return [4 /*yield*/, (onCreateDraft === null || onCreateDraft === void 0 ? void 0 : onCreateDraft(numPages, fabricDataMapJSON, noteField))];
                case 1:
                    userInCharge = _a.sent();
                    if (userInCharge === false) {
                        setShowNotPersonInCharge(true);
                        return [2 /*return*/];
                    }
                    closeSaveAndClose();
                    closePdfEditor();
                    return [2 /*return*/];
            }
        });
    }); };
    var cancel = function () {
        setNoteField(initalNote || '');
        closeSaveAndClose();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_bootstrap_1.Modal, { show: show, onHide: cancel, bsPrefix: 'aperza-app-modal', dialogClassName: 'aperza-app-dialog aperza-app', backdropClassName: 'aperza-app-backdrop', centered: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Body, { className: "p-4" },
                react_1.default.createElement(react_bootstrap_1.Container, { fluid: true },
                    react_1.default.createElement("h4", { className: "h4 text-primary mb-6 text-center" }, "\u30E1\u30E2"),
                    react_1.default.createElement("div", { className: "mb-6" },
                        react_1.default.createElement(AcFormField_1.AcFormField, __assign({}, formProps))))),
            react_1.default.createElement(react_bootstrap_1.Modal.Footer, { className: "justify-content-center text-primary" },
                react_1.default.createElement(AcButton_1.AcButton, { onClick: cancel, size: "lg", variant: "outline-apzlinkblue" }, "\u30AD\u30E3\u30F3\u30BB\u30EB"),
                react_1.default.createElement(AcButton_1.AcButton, { onClick: save, size: "lg", disabled: isNoteFieldError, variant: "cloudLink" }, "\u4FDD\u5B58\u3059\u308B"))),
        showNotPersonInCharge && (react_1.default.createElement(NotPersonInCharge_1.NotPersonInCharge, { closeNotPersonInChargeModal: function () { return setShowNotPersonInCharge(false); } }))));
};
exports.SaveAndClose.displayName = 'SaveAndClose';
//# sourceMappingURL=SaveAndClose.js.map